import { Alert, AlertTitle, Box } from '@mui/material'
import * as React from 'react'
import { InfoOutlined } from '@mui/icons-material'
import EndpointExamples from './EndpointExamples'
import CalculationExamples from './CalculationExamples'

// SyntaxHighlighter.registerLanguage('oxygene', oxygene)

export function Examples({ type }: { type: 'END' | 'CAL' }) {
  return (
    <Alert
      variant={'outlined'}
      severity={'info'}
      icon={false}
      sx={{ width: 1, my: 1 / 2, display: 'flex' }}
    >
      <Box sx={{ display: 'flex' }}>
        <InfoOutlined
          color={'info'}
          sx={{ mr: 1 }}
        />
        <AlertTitle>
          Example <strong>{type === 'END' ? 'Endpoint' : 'Calculation'}</strong>{' '}
          Explanations
        </AlertTitle>
      </Box>
      {type === 'END' ?
        <EndpointExamples />
      : <CalculationExamples />}
    </Alert>
  )
}
